import React, { useEffect, useState } from 'react'

import useWindowSize from '../../utils/hooks/useWindowSize'

const TwitchPlayer = (props) => {
  if(!props.channel) {
    return ''
  }

  const [onlineStatus, setOnlineStatus] = useState(false)
  const [modalDisplay, setModalDisplay] = useState(false)
  let isMobile = false
  const windowSize = useWindowSize()
  if (windowSize.width <= 991) {
    isMobile = true
  }
  const [openStream, setOpenStream] = useState(isMobile ? false : true)
  const twitchChannel = props.channel
  const twitchUserName = props.name ? props.name : props.channel
  
  // Use the "keepOn" props to display the popup at all time (whether the stream in offline or online)
  const keepOn = props.keepOn ? true : false

  const openStreamToggle = (e) => {
    if (openStream) {
      setOpenStream(false)
    } else {
      setOpenStream(true)
    }
  }

  const loadTwitch = (callback) => {
    if (typeof document !== `undefined`) {
      const existingScript = document.getElementById('twitchEmbedScript')
      if (!existingScript) {
        const script = document.createElement('script')
        script.src = 'https://embed.twitch.tv/embed/v1.js'
        script.id = 'twitchEmbedScript'
        document.body.appendChild(script); script.onload = () => {
          if (callback) callback()
        }
      } if (existingScript && callback) callback()
    }
  }

  useEffect(() => {
    loadTwitch(() => {
      const options = {
        channel: twitchChannel,
        layout: 'video'
      }
      const player = new Twitch.Player('twitch-embed', options)
      player.addEventListener(Twitch.Player.READY, initiate)

      function initiate() {
        player.addEventListener(Twitch.Player.ONLINE, handleOnline)
        player.addEventListener(Twitch.Player.OFFLINE, handleOffline)
        player.removeEventListener(Twitch.Player.READY, initiate)
      }

      function handleOnline() {
        setModalDisplay(true)
        setOnlineStatus(true)
        player.removeEventListener(Twitch.Player.ONLINE, handleOnline)
        player.addEventListener(Twitch.Player.OFFLINE, handleOffline)
        player.setMuted(false)
      }

      function handleOffline() {
        if(keepOn) {
          setModalDisplay(true)
        }
        setOnlineStatus(false)
        player.removeEventListener(Twitch.Player.OFFLINE, handleOffline)
        player.addEventListener(Twitch.Player.ONLINE, handleOnline)
        player.setMuted(true)
      }
    })
  }, [])

  const onlineMessage = 'is broadcasting now'
  const offlineMessage = 'is offline'

  return (
    <div className={`fixed right-20 md:right-28 bottom-6 z-god bg-white w-[calc(95%-5rem)] md:w-[48rem] p-4 shadow-black shadow-xl overflow-hidden h-auto transition-all duration-300 ${openStream ? 'max-h-full' : 'max-h-16 lg:max-h-[4.5rem]'} ${modalDisplay ? 'block' : 'hidden'}`}>
      <div className="flex justify-between items-center">
        <p className="text-[#000] font-bold text-sm sm:text-base md:text-[1.8rem]">
          <a href={`https://www.twitch.tv/${twitchChannel}`} rel="noopener noreferrer" target="_blank" className="text-[#772ce8]">{twitchUserName}</a> {onlineStatus ? onlineMessage : offlineMessage}
        </p>
        <button
          onClick={openStreamToggle}
          className={`z-10 flex h-8 w-8 p-0 items-center justify-center transition-all cursor-pointer`}
        >
          <span className={`icon-toggle ${openStream ? 'open' : ''}`} />
        </button>
      </div>
      <div
        className={`bg-[#000] h-72 sm:h-96 transition-all duration-500 mt-4 ${openStream ? 'opacity-1' : 'opacity-0'}`}
        id="twitch-embed"
      />
    </div>
  )
}
export default TwitchPlayer

